// extracted by mini-css-extract-plugin
export default {"step4":"Step4_step4__5IQAV","step4__content":"Step4_step4__content__EQDmb","step4__btn":"Step4_step4__btn__69fnF"};